"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientContextSwitch = void 0;
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalCss_1 = require("../../globalCss");
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var ClientLogo_1 = require("../ClientLogo/ClientLogo");
var Common_1 = require("../Common");
var Icon_1 = require("../Common/Icon");
var Modal_1 = require("../Modal/Modal");
var Pullout_1 = require("../Pullout");
var SelectHierarchy_1 = require("../Select/SelectHierarchy");
var ClientContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcolor: ", ";\n\tmargin-left: auto;\n\tdisplay: inline-flex;\n\tline-height: 12px;\n\tfont-weight: ", ";\n\tpadding-left: 13px;\n\tdisplay: block;\n"], ["\n\tcolor: ", ";\n\tmargin-left: auto;\n\tdisplay: inline-flex;\n\tline-height: 12px;\n\tfont-weight: ", ";\n\tpadding-left: 13px;\n\tdisplay: block;\n"])), globalVars_module_scss_1.default.secondaryGray1, globalVars_module_scss_1.default.fontWeightNormal);
ClientContainer.displayName = 'ClientContainer';
var ClientName = styled_components_1.default.div.attrs({
    className: 'tws-client-context-name',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfont-weight: ", ";\n\tcolor: ", ";\n\tfont-size: 10px;\n"], ["\n\tfont-weight: ", ";\n\tcolor: ", ";\n\tfont-size: 10px;\n"])), globalVars_module_scss_1.default.fontWeightBold, globalVars_module_scss_1.default.mainGray);
ClientName.displayName = 'ClientName';
var UnitName = styled_components_1.default.div.attrs({
    className: 'tws-client-context-unit',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-size: 9px;\n"], ["\n\tfont-size: 9px;\n"])));
UnitName.displayName = 'UnitName';
var PopupContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin-top: 60px;\n"], ["\n\tmargin-top: 60px;\n"])));
PopupContainer.displayName = 'PopupContainer';
var Description = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\tmargin-bottom: 30px;\n"], ["\n\t", "\n\tmargin-bottom: 30px;\n"])), globalCss_1.bodyCopyMedium);
Description.displayName = 'Description';
var ClientContextWrapper = styled_components_1.default.div.attrs({
    className: 'tws-client-context-wrapper',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tfont-weight: ", ";\n\tmax-height: 52px;\n\toverflow: hidden;\n\tdisplay: flex;\n\talign-items: center;\n\timg {\n\t\theight: 36px;\n\t}\n\t", "\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tfont-size: ", ";\n\t\tline-height: 1.1em;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\timg {\n\t\t\theight: 32px;\n\t\t}\n\t}\n\t@media (min-width: 0) and (max-width: 576px) {\n\t\tmax-width: 90px;\n\t\tword-break: break-word;\n\t}\n"], ["\n\tfont-weight: ", ";\n\tmax-height: 52px;\n\toverflow: hidden;\n\tdisplay: flex;\n\talign-items: center;\n\timg {\n\t\theight: 36px;\n\t}\n\t", "\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tfont-size: ", ";\n\t\tline-height: 1.1em;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\timg {\n\t\t\theight: 32px;\n\t\t}\n\t}\n\t@media (min-width: 0) and (max-width: 576px) {\n\t\tmax-width: 90px;\n\t\tword-break: break-word;\n\t}\n"])), globalVars_module_scss_1.default.fontWeightBold, function (props) { return (props.modal ? 'cursor: pointer;' : ''); }, globalVars_module_scss_1.default.fontSizeSmall);
ClientContextWrapper.displayName = 'ClientContextWrapper';
var StyledIcon = (0, styled_components_1.default)(Icon_1.Icon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tmargin-left: 12px;\n\tfont-size: 8px;\n"], ["\n\tmargin-left: 12px;\n\tfont-size: 8px;\n"])));
var SelectHierarchyContainer = (0, styled_components_1.default)(SelectHierarchy_1.SelectHierarchy)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tz-index: 900;\n\tmargin-top: 30px;\n"], ["\n\tz-index: 900;\n\tmargin-top: 30px;\n"])));
SelectHierarchyContainer.displayName = 'SelectHierarchyContainer';
var defaultClient = {
    clientId: 0,
    name: '',
    unit: '',
};
var ClientContextSwitch = /** @class */ (function (_super) {
    __extends(ClientContextSwitch, _super);
    function ClientContextSwitch(props) {
        var _this = _super.call(this, props) || this;
        _this.hasAccessToClients = function () {
            var clients = _this.props.clients;
            return clients && clients.length > 0;
        };
        _this.state = {
            isModalOpen: false,
            selectedValue: undefined,
        };
        _this.handleRadioHierarchyChange = _this.handleRadioHierarchyChange.bind(_this);
        _this.onClientContextSwitch = _this.onClientContextSwitch.bind(_this);
        return _this;
    }
    ClientContextSwitch.prototype.componentDidMount = function () {
        this.props.GetClients(this.props.userManagementBaseUrl);
    };
    ClientContextSwitch.prototype.componentDidUpdate = function (prevProps, prevState) {
        var clients = this.props.clients;
        if (!prevProps.clientsLoaded && !prevProps.clientsLoaded && this.props.clientsLoaded) {
            var selectedClient = lodash_1.default.find(clients, { clientId: this.getClientId() });
            if (selectedClient && prevState.selectedValue === '') {
                this.setState({ selectedValue: selectedClient.clientId + '' });
            }
            if (!selectedClient && !prevState.isModalOpen) {
                this.setState({ isModalOpen: true });
            }
        }
    };
    ClientContextSwitch.prototype.render = function () {
        var _this = this;
        var clients = this.props.clients;
        var selectedClient = lodash_1.default.find(clients, { clientId: this.getClientId() });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ClientContextWrapper, { modal: clients.length > 1, onClick: function () {
                    return clients.length > 1 &&
                        _this.setState({ isModalOpen: true, selectedValue: selectedClient ? selectedClient.clientId + '' : undefined });
                } },
                clients.length > 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ClientLogo_1.ClientLogoDivider, { className: 'tws-clientlogo-divider' }),
                    selectedClient ? (react_1.default.createElement(ClientContainer, null,
                        react_1.default.createElement(ClientName, null, selectedClient.name),
                        react_1.default.createElement(UnitName, null, selectedClient.unit))) : (react_1.default.createElement(ClientContainer, null,
                        react_1.default.createElement(ClientName, null, "Choose a client"))),
                    react_1.default.createElement(StyledIcon, { name: 'caret-down' }))),
                clients.length === 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ClientLogo_1.ClientLogoDivider, { className: 'tws-clientlogo-divider' }),
                    selectedClient && (react_1.default.createElement(ClientContainer, null,
                        react_1.default.createElement(ClientName, null, selectedClient.name),
                        react_1.default.createElement(UnitName, null, selectedClient.unit)))))),
            this.state.isModalOpen && (react_1.default.createElement(Modal_1.ModalPopup, { isOpen: this.state.isModalOpen, stayOpen: !this.hasAccessToClients(), title: this.hasAccessToClients() ? 'Change Client' : 'Error', primaryButtonText: this.hasAccessToClients() ? 'Change Client' : 'Logout', secondaryButtonText: this.hasAccessToClients() ? 'Cancel' : undefined, contentfullwidth: false, contenthcentered: true, contentoverflow: true, onClosed: function () { return _this.setState({ isModalOpen: false, selectedValue: undefined }); }, onSubmit: function () { return _this.onClientContextSwitch(); }, primaryButtonDisabled: this.shouldChangeClientBeDisabled(selectedClient) },
                react_1.default.createElement("div", null, this.hasAccessToClients() ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Description, null, "Use the dropdown below to search and select a new client. If you do not find the client you're looking for this means you don't have permissions to this client."),
                    react_1.default.createElement(Pullout_1.Pullout, { type: Pullout_1.PulloutType.Warning },
                        react_1.default.createElement("strong", null, "WARNING: "),
                        " None of your unsaved data will be kept and you will automatically be logged out of any other open tabs or pages."),
                    react_1.default.createElement(SelectHierarchyContainer, { items: this.transFormClients(this.props.clients), selectSize: 'xlg', dropdownSize: 'md', showSearch: true, placeHolderText: 'Search', onRadioChange: this.handleRadioHierarchyChange, selectedValue: this.state.selectedValue }),
                    !selectedClient &&
                        Common_1.MessageHelper.getFormattedErrorMessages('There is currently an invalid/no client selected for your account.'))) : (react_1.default.createElement(react_1.default.Fragment, null, Common_1.MessageHelper.getFormattedErrorMessages("You do not have any access to any client, \n\t\t\t\t\t\t\t\tplease contact your support team"))))))));
    };
    ClientContextSwitch.prototype.getClientId = function () {
        var clientId = -1;
        var keys = Object.keys(localStorage);
        var key = lodash_1.default.find(keys, function (x) { return x.startsWith('oidc.user'); });
        var user = JSON.parse(localStorage.getItem(key));
        if (user && user.profile && user.profile.external_clientid) {
            clientId = parseInt(user.profile.external_clientid, 0);
        }
        return clientId;
    };
    ClientContextSwitch.prototype.shouldChangeClientBeDisabled = function (client) {
        if (this.hasAccessToClients()) {
            if (client) {
                return this.state.selectedValue === client.clientId + '';
            }
            return this.state.selectedValue === undefined;
        }
        return false;
    };
    ClientContextSwitch.prototype.onClientContextSwitch = function () {
        var _this = this;
        var _a;
        if (this.hasAccessToClients()) {
            var newClient = (_a = lodash_1.default.find(this.props.clients, function (c) { return c.clientId === parseInt(_this.state.selectedValue, 0); })) !== null && _a !== void 0 ? _a : defaultClient;
            this.props.ChangeClientContext(newClient, this.props.identityServerUrl);
        }
        else {
            if (this.props.logout) {
                this.props.logout(this.props.userManager, this.props.identityServerUrl);
            }
        }
    };
    ClientContextSwitch.prototype.transFormClients = function (clients) {
        var result = [];
        for (var _i = 0, clients_1 = clients; _i < clients_1.length; _i++) {
            var client = clients_1[_i];
            result.push({
                id: client.clientId + '',
                name: client.clientId + '',
                displayText: client.name + ' - ' + client.unit,
            });
        }
        return result;
    };
    ClientContextSwitch.prototype.handleRadioHierarchyChange = function (value) {
        this.setState({ selectedValue: value });
    };
    return ClientContextSwitch;
}(react_1.default.Component));
exports.ClientContextSwitch = ClientContextSwitch;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
